import script from "./Contato.vue?vue&type=script&setup=true&lang=js"
export * from "./Contato.vue?vue&type=script&setup=true&lang=js"

import "./Contato.vue?vue&type=style&index=0&id=7a67b4b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a67b4b9"]])

export default __exports__